export function getMaxNumberOfCollaborators(plan) {
    return plan
        ? plan.maxNumberOfTeamMembers === -1
            ? Infinity
            : plan.maxNumberOfTeamMembers
        : 0;
}

export function isPlanFree(plan) {
    return plan.subscriptions && plan.subscriptions.length === 1 && plan.subscriptions[0].price === 0;
}

export function isPlanCustom(plan) {
    return !plan.subscriptions || plan.subscriptions.length === 0;
}



// WEBPACK FOOTER //
// ./src/common/util/plan.util.js